
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.90576 5C7.66985 5 7.4408 5.09688 7.26983 5.27385C7.09843 5.45125 7 5.69448 7 5.95061V18.0493C7 18.3055 7.09843 18.5487 7.26983 18.7261C7.4408 18.9031 7.66985 19 7.90576 19H13.1659L13.1671 19C13.9259 19.0034 14.6695 18.7717 15.3022 18.3331C15.9352 17.8944 16.4287 17.2683 16.7172 16.5338C17.0058 15.7993 17.0756 14.9916 16.9171 14.2151C16.7586 13.4386 16.3795 12.7308 15.8306 12.1819L15.6492 12.0006L15.83 11.8186C16.1963 11.45 16.4884 11.0086 16.6885 10.5201C16.8886 10.0316 16.9926 9.50629 16.994 8.97503C16.9939 8.45135 16.8942 7.93308 16.7009 7.4499C16.5075 6.96665 16.2243 6.52836 15.8682 6.15976C15.5121 5.79118 15.0901 5.49953 14.6265 5.3008C14.163 5.10209 13.6668 5 13.1659 5H7.90576ZM8.81152 6.90123H13.1659C13.705 6.90123 14.2193 7.12302 14.5963 7.51329C14.973 7.90312 15.1824 8.42924 15.1824 8.9753C15.1824 9.52136 14.973 10.0475 14.5963 10.4373C14.2193 10.8276 13.705 11.0494 13.1659 11.0494H8.81152V6.90123ZM8.81152 12.9506H13.1659C13.705 12.9506 14.2193 13.1724 14.5963 13.5627C14.973 13.9525 15.1824 14.4786 15.1824 15.0247C15.1824 15.5707 14.973 16.0968 14.5963 16.4867C14.2193 16.8769 13.705 17.0987 13.1659 17.0987H8.81152V12.9506Z","fill":"#10001F"}})])
          )
        }
      }
    